import { useEffect } from 'react';

const RedirectToExternal = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null; // This component doesn't render anything
};

export default RedirectToExternal; 